import {
  AfterContentChecked,
  AfterContentInit,
  Directive,
  ElementRef,
  Input,
} from '@angular/core';

@Directive({
  selector: '[pseicAutofocus]'
})
export class PseicAutofocusDirective implements AfterContentInit, AfterContentChecked {
  // Is multiple focusable elements on view
  @Input('pseicAutofocus') isMultiple?: boolean = false;

  constructor(private elementRef: ElementRef) {
  }

  ngAfterContentInit(): void {
    this.elementRef.nativeElement.focus();
  }

  ngAfterContentChecked(): void {
    if (!this.isMultiple) {
      this.elementRef.nativeElement.focus();
    }
  }
}
